export const minWidth = 100;
